import React, { FC, ReactElement, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setNewPaymentcheckBox } from '../../features/OfferPaymentContainer/OfferPaymentSlice';
import withLocalization from '../hoc/withLocalization';
import { RootState } from '../../redux/rootReducer';
import ParseHtml from '../common/ParseHtml';
import './PaymentDetailsPage.scss';
import isAsia from '../../util/isAsia';
import ParticipationDetails from '../ParticipationDetails/ParticipationDetails';

const TermsAndConditionPage: FC<any> = (props: any): ReactElement => {
  const { localize } = props;
  const isPaymentCheck = useSelector((state: RootState) => state.newOfferPaymentDetails.isPaymentCheckBox);

  const finalOfferData: any = useSelector((state: RootState) => state.offerDetails.pinOptOfferDetails);
  const [participationModalOpen, setParticipationModalOpen] = useState(false);
  const offerData: any = (finalOfferData?.offers && finalOfferData?.offers[0]) || '';
  const tourType = offerData?.tourTp || '';
  const isTr: boolean = tourType && tourType.toUpperCase() === 'TR' ? true : false;

  let ackDec: any;
  if (isAsia) {
    ackDec = isTr
      ? localize(`preview-sales-engine.static-content.copy.pbeo.intl.asia-payment-form-acknowledgement`)
      : localize(`preview-sales-engine.static-content.copy.pbeo.intl.asia-tnr-payment-form-acknowledgement`);
  } else {
    ackDec = isTr
      ? localize(`preview-sales-engine.static-content.copy.pbeo.intl.me-payment-form-acknowledgement`)
      : localize(`preview-sales-engine.static-content.copy.pbeo.intl.me-payment-form-acknowledgement-tnr`);
  }

  const dispatch = useDispatch();
  const handleCheckboxClick = () => {
    dispatch(setNewPaymentcheckBox(!isPaymentCheck));
  };
  //const handleCheckboxChange = (evt: any) => {};

  //const handleKeyDown = () => {};
  const openParticipationModal = () => {
    setParticipationModalOpen(true);
  };
  const closeModal = () => {
    setParticipationModalOpen(false);
  };
  return (
    <>
      {participationModalOpen && <ParticipationDetails closeModal={closeModal} />}
      <div
        className="checkRowContainer-payment"
        /*onKeyDown={handleKeyDown}
        aria-label={'check-payment'}
        role="button"
        tabIndex={0}
        onClick={handleCheckboxClick}*/
      >
        <div className="custom-checkbox-wrapper" id="checkboxWrapper">
          <input
            type="checkbox"
            checked={isPaymentCheck}
            className="custom-checkbox"
            id="checkBox-billing"
            aria-label="billing-checkBox"
            onClick={handleCheckboxClick}
          />
        </div>
        <div className="ack-payment-container">
          <ParseHtml htmlInput={ackDec}></ParseHtml>
          <button className="ack-detail-Paticipate" onClick={() => openParticipationModal()}>
            {localize('preview-sales-engine.static-content.copy.pbeo.intl.view-terms-label')}
          </button>
        </div>
      </div>

      {/*<div className="dop-payment-container">
        <button className="ack-detail-Paticipate" onClick={() => openParticipationModal()}>
          {localize('preview-sales-engine.static-content.copy.pbeo.dop-link-label')}
        </button>
      </div>*/}
    </>
  );
};

export default withLocalization(TermsAndConditionPage);
